import { gql } from '@apollo/client';
import { getApolloClient } from '../apolloClient';
import { createRegistration } from '../graphql/mutations';
import { CreateRegistrationInput, Registration } from '../API';

export async function createRegistrationRecord(input: CreateRegistrationInput): Promise<Registration> {
    console.log('addEventUser input: ', input);
    try {
        const client = await getApolloClient();
        const { data } = await client.mutate<{ createRegistration: Registration }>({
            mutation: gql`
                ${createRegistration}
            `,
            variables: { input },
        });
        if (!data) {
            throw new Error('No data returned from mutation');
        }
        return data.createRegistration;
    } catch (err) {
        console.error('Error creating event user:', err);
        throw err;
    }
}